import type {ReactAction} from '@netx/core/bootstrap';
import {faTrashAlt} from '@netx/core-icons';
import {type ICategory} from '@netx/core-category-next/schema';
import {canDeleteCategory} from '../enablers';
import {CategoryActionLabel} from '../locales';
import {CATEGORY_EVENT} from './constants';

export const categoryActionDeleteIcon = faTrashAlt;

/**
 * Delete category
 * @param params
 * @returns Action
 */
export const categoryActionDelete = (
	category?: ICategory,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'category-delete',
	cb: () => dispatcher.trigger(CATEGORY_EVENT.DELETE, category),
	enableTest: () => canDeleteCategory(category),
	icon: categoryActionDeleteIcon,
	get label() {
		return CategoryActionLabel.DELETE;
	},
	...params,
});

export default categoryActionDelete;
